import Vue from "vue";
import VueI18n from "vue-i18n";
import Cookies from "js-cookie";

import enLocale from "./en";
import zhLocale from "./zh";
import esLocale from "./es";
import frLocale from "./fr";

Vue.use(VueI18n);

const messages = {
  en: {
    ...enLocale
  },
  zh: {
    ...zhLocale
  },
  es: {
    ...esLocale
  },
  fr: {
    ...frLocale
  }
};
var lang = Cookies.get("language")
  ? Cookies.get("language")
  : (navigator.language || navigator.userLanguage).substr(0, 2); //常规浏览器语言和IE浏览器
const i18n = new VueI18n({
  locale: lang,
  messages
});

export default i18n;



// WEBPACK FOOTER //
// ./src/lang/index.js